/**
 *导航菜单
 *@author xujinjiang
 *@date 2022/3/1 17:16
 */
export const Menu = {
  home: {
    path: 'home',
    title: '首页'
  },
  institutions: {
    path: 'institutions',
    title: '机构管理'
  },
  authorizationUser: {
    path: 'authorization-user',
    title: '授权用户管理'
  },
  account: {
    path: 'account',
    title: '账户'
  },
  accountManage: {
    path: 'account-manage',
    title: '账号管理'
  },
  accountLog: {
    path: 'account-log',
    title: '操作日志'
  },
  doc: {
    path: '/',
    title: '开发与帮助文档'
  }
};
